import fetch from "cross-fetch"
import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client"

import resolvers from "../graphql/resolvers"

const domain = process.env.GATSBY_SHOPIFY_STOREFRONT_DOMAIN || 'not-pot.myshopify.com'
const token = process.env.GATSBY_SHOPIFY_STOREFRONT_TOKEN

if (!token && typeof window !== 'undefined') {
  console.error('Warning: GATSBY_SHOPIFY_STOREFRONT_TOKEN is not set. Apollo client may not work correctly.')
}

export const client = new ApolloClient({
  ssrMode: false,
  link: new HttpLink({
    uri: `https://${domain}/api/2020-07/graphql.json`,
    headers: {
      "X-Shopify-Storefront-Access-Token": token,
    },
    fetch,
  }),
  cache: new InMemoryCache().restore({}),
  resolvers,
})
